import apiClient from "./APIClient";

export const createTicket = async (formData) => {
  return apiClient.post("/ticket-mng", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const createTicketC = async (formData) => {
  return apiClient.post("/customer", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getTicketTypes = async () => {
  const res = await apiClient.get("/ticket-types");
  return res.data.data; 
};
export const getTicketTypesC = async () => {
  const res = await apiClient.get("/customer/type");
  return res.data.data; 
};

export const getMerchantTickets = async (params = {}) => {
  const res = await apiClient.get("/ticket-mng", { params });
  return res.data; 
};
export const getCustomerTickets = async (params = {}) => {
  const res = await apiClient.get("/customer", { params });
  return res.data; 
};
